import {
    HIDE_CUSTOMER_VEHICLES_SLIDEOUT,
    SET_DEAL_LIST_COMPARE_ENABLED,
    SHOW_CUSTOMER_VEHICLES_SLIDEOUT,
    SELECTED_DEAL,
    SHOW_TRADE_IN_MODAL,
    HIDE_TRADE_IN_MODAL
} from './actions';

export const showCustomerVehiclesSlideout = (customerFirstName?: string) => ({
    type: SHOW_CUSTOMER_VEHICLES_SLIDEOUT,
    payload: { customerFirstName }
});

export const hideCustomerVehiclesSlideout = () => ({
    type: HIDE_CUSTOMER_VEHICLES_SLIDEOUT
});

export const setDealListCompareEnabled = (enabled: boolean) => ({
    type: SET_DEAL_LIST_COMPARE_ENABLED,
    payload: enabled
});

export const setSelectedDeal = (dealId: string, version: string) => ({
    type: SELECTED_DEAL,
    payload: { dealId, version }
});

export const showTradeInModal = () => ({
    type: SHOW_TRADE_IN_MODAL
});

export const hideTradeInModal = () => ({
    type: HIDE_TRADE_IN_MODAL
});
